/**
 * Constructs a label for entries based on specified parameters.
 *
 * @param {Object} params - The parameters for constructing the label.
 * @param {string} [params.companyName] - The company name to be used as the base for the label.
 * @param {string} [params.domain] - The domain to be used as the base for the label if company name is not provided.
 * @param {Array<string>} [params.groups] - An array of group names to be included in the label, if specified in labelSettings.
 * @param {string} [params.country] - The country code to be included in the label, if specified in labelSettings.
 * @param {Object} [params.labelSettings] - Additional settings for constructing the label.
 * @param {boolean} [params.labelSettings.groupNames] - If true, include group names in the label.
 * @param {boolean} [params.labelSettings.countryCode] - If true, include country code in the label.
 *
 * @returns {string} - The constructed label for entries.
 */
const constructEntriesLabel = ({ companyName, domain, groups, country, labelSettings }) => {
  // Determine the base for the label
  const base = companyName || domain;

  // Prepare additional information based on label settings
  const additionalInfo = [
    ...(labelSettings.groupNames ? groups : []),
    ...(labelSettings.countryCode && country ? [country] : []),
  ];

  // Generate the postfix for the label
  const postFix = additionalInfo.length ? ` (${additionalInfo.join(', ')})` : '';

  // Combine the base and postfix to create the final label
  return base + postFix;
};

export default constructEntriesLabel;
